module.exports = __webpack_public_path__ + "static/img/jiat-innovation.52d53dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/jiat-innovation.jpg
// module id = bWIh
// module chunks = 0